var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566 566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#0078bd;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 283,
    cy: 283,
    r: 283
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.87,162.76c9.69,0,19.37-.04,29.06,0,24.47,.13,47.14,6.61,67.95,19.45,20.42,12.61,35.93,29.74,46.19,51.46,4.75,10.06,7.72,20.7,9.51,31.71,1.4,8.61,1.69,17.25,1.19,25.87-.72,12.52-3.85,24.57-8.83,36.11-7.16,16.59-17.76,30.7-31.14,42.69-16.79,15.05-36.25,25.17-58.24,30.25-8.56,1.98-17.29,2.96-26.11,2.94-19.76-.04-39.52,0-59.28-.02-18.4-.02-35.82-4.24-52.35-12.3-10.98-5.35-20.83-12.24-29.75-20.57-17.13-15.99-28.61-35.33-34.5-57.98-3.03-11.66-4.04-23.58-3.35-35.56,1.01-17.71,5.21-34.65,13.45-50.46,6.66-12.8,15.38-23.99,26.22-33.57,14.87-13.14,31.99-21.88,51.21-26.43,6.48-1.53,13.16-2.77,19.79-3,12.98-.47,26-.14,39-.14v-.46Zm-138.49,120c-.51,60.76,49.25,110.31,109.62,110.53,62.26,.23,109.61-49.33,111.19-107.02,1.77-64.32-49.47-113.41-109.07-114.06-62.77-.68-112.33,50.38-111.75,110.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M142.38,282.76c-.58-60.16,48.98-111.22,111.75-110.54,59.6,.64,110.84,49.74,109.07,114.06-1.59,57.68-48.93,107.25-111.19,107.02-60.38-.23-110.14-49.77-109.62-110.53Zm84.97-64.57c-23.26,8.3-48.39,35.75-43.62,73.71,1.9,15.09,8.38,28.12,18.92,39.08,6.96,7.24,15.06,12.78,24.7,16.51V218.19Zm50.86,.03v128.88c19.75-6.43,42.1-28.42,44.05-59.87,2.12-34.1-19.88-60.13-44.05-69.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M227.35,218.19v129.3c-9.64-3.73-17.74-9.27-24.7-16.51-10.54-10.97-17.03-23.99-18.92-39.08-4.77-37.96,20.36-65.4,43.62-73.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.21,218.22c24.17,8.88,46.17,34.91,44.05,69.01-1.95,31.45-24.31,53.44-44.05,59.87V218.22Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.d13beeec7d2155aacea7336710df9c69.svg";
export { ForwardRef as ReactComponent };